import { render, staticRenderFns } from "./TaskBlockEdit.vue?vue&type=template&id=1dee8a24&scoped=true&"
import script from "./TaskBlockEdit.vue?vue&type=script&lang=js&"
export * from "./TaskBlockEdit.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockEdit.vue?vue&type=style&index=0&id=1dee8a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee8a24",
  null
  
)

export default component.exports